<form [formGroup]="formFilter" cForm class="container-filter">

  <mat-form-field>
    <mat-label>Busqueda</mat-label>
    <input id="inputGeneral" matInput
      (keyup.enter)="filtroGeneral($event)"
      (input)="filtroGeneralTemporizado($event)"
      formControlName="generalFilter"
      placeholder="Busqueda "
    />
  </mat-form-field>
  
</form>
  